import React from 'react';
import { get } from 'lodash/fp';
import { findDOMNode } from 'react-dom';
import { compose } from 'redux';
import { connect } from 'react-redux';
import AdjacentAction from 'components/shared/AdjacentAction';
import { hasGlobalFeature } from 'selectors';
import { modeSelectors } from 'selectors/pathBuilder';
import * as actions from '../../../actions/pathBuilder/contents';
import DropTarget from './DropTarget.js';
import { adderOptions } from './stepOptions';

const mapPropsToOptions = props => {
  const { lesson, path, placeholder, demonstration, waitStep, certification } =
    adderOptions;
  const result = [lesson, waitStep];
  result.push(path);
  result.push(certification);
  if (!props.isPublished) {
    result.push(placeholder);
  }
  if (props.features.demonstrations && props.isCertification) {
    result.push(demonstration);
  }
  return result;
};

const PathAdjacentAction = props => {
  const {
    add, // Function: (via connect)
    connectDropTarget, // Function: (via DropTarget)
    editingMode, // Boolean: (via connect)
    canDrop, // Boolean: (via DropTarget)
    isOver, // Boolean: (via DropTarget)
  } = props;
  const isHovering = canDrop && isOver;
  return (
    <div className="PathAdjacentAction">
      {editingMode && (
        <AdjacentAction
          icon="add"
          label={isHovering ? 'Move Step Here' : 'Add Step'}
          options={mapPropsToOptions(props)}
          onActionClick={add}
          active={isHovering}
          ref={node => {
            // eslint-disable-next-line react/no-find-dom-node
            const DOMRef = findDOMNode(node);
            connectDropTarget(DOMRef);
          }}
        />
      )}
    </div>
  );
};

const mapStateToProps =
  () =>
  ({ pathBuilder, ...state }) => ({
    isPublished: !!get('publishedAt.date')(pathBuilder),
    editingMode: modeSelectors.isEdit(pathBuilder),
    isCertification: !!get('certification')(pathBuilder),
    features: {
      demonstrations: hasGlobalFeature(state, 'demonstrations'),
    },
  });

const mapDispatchToProps = (dispatch, { position }) => ({
  add: type => dispatch(actions.add(type, position)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  DropTarget,
)(PathAdjacentAction);
